/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_MonitoringInputs */

const en_activity_monitoring = /** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activity monitoring`)
};

const es_activity_monitoring = /** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitoreo de actividad`)
};

const fr_activity_monitoring = /** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Surveillance de l'activité`)
};

const de_activity_monitoring = /** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivitätsüberwachung`)
};

const id_activity_monitoring = /** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pemantauan aktivitas`)
};

/** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */
const ja_activity_monitoring = en_activity_monitoring;

/** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */
const zh_activity_monitoring = en_activity_monitoring;

/** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */
const ar_activity_monitoring = en_activity_monitoring;

/** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */
const it_activity_monitoring = en_activity_monitoring;

/** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */
const ru_activity_monitoring = en_activity_monitoring;

/** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */
const pt_activity_monitoring = en_activity_monitoring;

/** @type {(inputs: Activity_MonitoringInputs) => LocalizedString} */
const ko_activity_monitoring = en_activity_monitoring;

/**
* | output |
* | --- |
* | "Activity monitoring" |
*
* @param {Activity_MonitoringInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const activity_monitoring = /** @type {((inputs?: Activity_MonitoringInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_MonitoringInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activity_monitoring(inputs)
	if (locale === "es") return es_activity_monitoring(inputs)
	if (locale === "fr") return fr_activity_monitoring(inputs)
	if (locale === "de") return de_activity_monitoring(inputs)
	if (locale === "ja") return ja_activity_monitoring(inputs)
	if (locale === "zh") return zh_activity_monitoring(inputs)
	if (locale === "ar") return ar_activity_monitoring(inputs)
	if (locale === "id") return id_activity_monitoring(inputs)
	if (locale === "it") return it_activity_monitoring(inputs)
	if (locale === "ru") return ru_activity_monitoring(inputs)
	if (locale === "pt") return pt_activity_monitoring(inputs)
	return ko_activity_monitoring(inputs)
});